export const config = {
 bucketName: "serenetax",
 dirName: "documents",
 region: "ap-south-1",
 accessKeyId: 'AKIAXYKJWDQ7HXMD5WC4',
 secretAccessKey: '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',
};
